import { Checkbox } from "@volca/ui/components/ui/checkbox";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import { cn } from "@volca/ui/lib/utils";
import {
  getCarriedAlongSheetNames,
  getRerunScope,
  namesOwnSheet,
  type RerunUnit,
} from "@/payroll/pay-breakdown/rerun-units";
import { formatList } from "@/payroll/pay-breakdown/utils";

export const RerunUnitOption = ({
  unit,
  checked,
  onToggle,
}: {
  unit: RerunUnit;
  checked: boolean;
  onToggle: (checked: boolean) => void;
}) => {
  const isBusy = getRerunScope([unit]).length === 0;
  const carried = getCarriedAlongSheetNames(unit);
  const id = `rerun-unit-${unit.id}`;
  const subline = isBusy
    ? "Already running"
    : [
        namesOwnSheet(unit) ? null : formatList(unit.rerunSheetNames),
        carried.length > 0 &&
          `${formatList(carried)} recalculate${carried.length === 1 ? "s" : ""} with ${unit.rerunSheetNames.length === 1 ? "it" : "them"}`,
      ]
        .filter(Boolean)
        .join(" · ");

  return (
    <Stack
      direction="row"
      align="start"
      gap={2}
      className={cn("w-full", "rounded-md px-1 py-1", { "opacity-50": isBusy })}
    >
      <Checkbox
        id={id}
        checked={checked}
        disabled={isBusy}
        onCheckedChange={(next) => onToggle(next === true)}
        className="mt-0.5"
      />
      <label htmlFor={id} className={cn({ "cursor-pointer": !isBusy })}>
        <Stack align="start" gap={0}>
          <Text variant="caption" className="font-semibold">
            {unit.name}
          </Text>
          {subline && (
            <Text variant="caption" tone="muted">
              {subline}
            </Text>
          )}
        </Stack>
      </label>
    </Stack>
  );
};
